import React from 'react';

const ProductsHero = () => {
  // Background image path (can be easily changed)
  const backgroundImage = '/images/hero-background4.jpeg';

  return (
    <section className="products-hero relative py-20 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url("${backgroundImage}")`
        }}
      ></div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/55 to-san-marino/55"></div>
     

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Our Products
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto">
          Premium material handling equipment designed for safety, durability, and performance
        </p>
      </div>
    </section>
  );
};

export default ProductsHero;